var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(0.000000, 2.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1818286,3.1999875 L15.5454476,3.1999875 L13.0908951,3.1999875 L13.0908951,0.7999875 C13.0909335,0.3583875 12.7252052,0 12.2727238,0 L5.72727621,0 C5.27483317,0 4.90910486,0.3583875 4.90910486,0.7999875 L4.90910486,3.1999875 L2.45455243,3.1999875 L0.818171358,3.1999875 C0.365728312,3.1999875 0,3.558375 0,3.999975 C0,4.441575 0.365689959,4.8 0.818171358,4.8 L1.63634272,4.8 L1.63634272,16.8 C1.63634272,18.1231875 2.73763136,19.2 4.09089514,19.2 L13.9091049,19.2 C15.2623686,19.2 16.3636573,18.1231875 16.3636573,16.8 L16.3636573,4.8 L17.1818286,4.8 C17.6342717,4.8 18,4.4416125 18,4.0000125 C18,3.5584125 17.63431,3.1999875 17.1818286,3.1999875 Z M6.54544757,1.6000125 L11.4545524,1.6000125 L11.4545524,3.200025 L6.54544757,3.200025 L6.54544757,1.6000125 Z M14.7273146,16.8 C14.7273146,17.2408125 14.3607425,17.5999875 13.9091049,17.5999875 L4.09089514,17.5999875 C3.6392575,17.5999875 3.27272379,17.240775 3.27272379,16.8 L3.27272379,4.8 L5.72727621,4.8 L12.2727621,4.8 L14.7273146,4.8 L14.7273146,16.8 L14.7273146,16.8 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54544757,6.4000125 C6.09300453,6.4000125 5.72727621,6.7584 5.72727621,7.2 L5.72727621,14.4 C5.72727621,14.8416 6.09300453,15.1999875 6.54544757,15.1999875 C6.99789062,15.1999875 7.36361893,14.8416 7.36361893,14.4 L7.36361893,7.2 C7.36361893,6.7584 6.99789062,6.4000125 6.54544757,6.4000125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4545524,6.4000125 C11.0021094,6.4000125 10.6363811,6.7584 10.6363811,7.2 L10.6363811,14.4 C10.6363811,14.8416 11.0021094,15.1999875 11.4545524,15.1999875 C11.9069955,15.1999875 12.2727238,14.8416 12.2727238,14.4 L12.2727238,7.2 C12.2727238,6.7584 11.9069955,6.4000125 11.4545524,6.4000125 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.04ab2e0b7f4e03cc65f80912801b6c65.svg";
export { ForwardRef as ReactComponent };